export const getTelephonyProvidersUrl = () => '/telephony_providers';
